export default __webpack_public_path__ + "static/media/github-icon.342ed657.svg";